import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950 text-zinc-100 p-6">
        <div className="max-w-lg w-full rounded border border-red-500/30 bg-red-950/40 p-6 space-y-4">
          <h1 className="text-lg font-semibold text-red-200 uppercase tracking-wide">
            Something went wrong
          </h1>
          <p className="text-sm text-red-100/80">
            The app hit an unexpected error. Reloading should recover the session. If it keeps
            happening, your authentication state may be stale — sign out and back in.
          </p>
          <pre className="text-[11px] text-red-200/70 bg-black/40 rounded p-3 overflow-auto max-h-40">
            {this.state.error.message}
          </pre>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={this.handleReload}
              className="btn btn-primary btn-sm"
            >
              Reload
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
